import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations";
import { storedLanguage, supportedLanguages } from "./languages";

export { LANGUAGES, rememberLanguage, supportedLanguages } from "./languages";

// Choix du client s'il en a fait un, sinon la langue du navigateur, sinon le français.
const initialLanguage = () => {
    const supported = supportedLanguages();
    const stored = storedLanguage();
    if (supported.includes(stored)) return stored;

    const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
    const browser = browserLanguages
        .map((lang) => (lang || "").slice(0, 2).toLowerCase())
        .find((lang) => supported.includes(lang));

    return browser || "fr";
};

i18n
    .use(initReactI18next)
    .init({
        resources: translations,
        lng: initialLanguage(),
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
